export async function subscribe(email, turnstileToken, website = '', gym = false) {
  const response = await fetch(gym ? '/api/gym/newsletter' : '/api/newsletter', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, consent: true, turnstileToken, website }), signal: AbortSignal.timeout(25000),
  });
  if (!response.ok) throw new Error(response.status === 400
    ? 'Please check your email address and complete verification again.'
    : 'Signup is temporarily unavailable. Please try again later.');
  return response.json();
}
